import Crud from '../components/Event/Crud.vue'
import View from '../components/Event/View.vue'

let routes = {
    path: '/events',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/events',
            name: 'Eventos',
            component: Crud
        },
        {
            path: '/events/view/:id',
            name: 'Evento',
            component: View
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/event.js